import Calc from '../modules/calc';

class Cart extends Calc {
    constructor() {
        super();
        this.eventsCart();
    }

    eventsCart() {
        this.btn.onclick = (e) => {  
            e.preventDefault();
            if(this.wire_type.value == -1) {
                return
            }

            let cost = document.getElementById('estimated_cost').textContent;
            let desc = document.getElementById('cable_desc').textContent;
            this.btn.innerHTML = "Please, wait...";
            this.addToCart(1, cost, desc);
        
        }
    }


    addToCart(product_qty, custom_price, desc) {

    let data = {
        action: 'woocommerce_ajax_add_to_cart',
        product_qty: product_qty,
        custom_price: custom_price,
        desc: desc
    };

    jQuery(document.body).trigger('adding_to_cart', data);

    jQuery.ajax({
        type: 'post',
        // url: wc_add_to_cart_params.ajax_url,
        url: woocommerce_params.ajax_url,
        data: data,
        // beforeSend: function (response) {
        //     console.log('loading');
        // },
        // complete: function (response) {
        //     console.log('loaded');
        //     console.log(response);
        // },
        success: function (response) {

            if (response.error & response.product_url) {
                window.location = response.product_url;
                return;
            } else {
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
                console.log('success');
                jQuery('#custom_add_to_cart').html("Add To Cart");
                jQuery('#custom-item-added-desc').html(data.desc);
                jQuery('#custom-woocommerce-notices-wrapper').slideDown();
                // jQuery('#custom-woocommerce-notices-wrapper').get(0).scrollIntoView()
                jQuery('html, body').animate({ scrollTop: 0}, 1000);
            }
                // window.scrollTo({top: 0});

            
        },
    });
};
}

export default Cart;




